"use client";

import React from "react";
import { Sidebar } from "@/components/Sidebar";
import { useLayout } from "@/contexts/LayoutContext";
import { cn } from "@/lib/helpers/utils";

export function ClientLayout({ children }: { children: React.ReactNode }) {
    const { isSidebarCollapsed } = useLayout();

    return (
        <div className="flex min-h-screen bg-background w-full overflow-x-hidden">
            <Sidebar />
            {/* Content area - dynamically adjust left margin based on sidebar state */}
            <main
                className={cn(
                    "flex-1 w-full md:p-8 overflow-x-hidden pb-20 md:pb-0 transition-all duration-300 ease-in-out",
                    isSidebarCollapsed ? "md:ml-20" : "md:ml-64"
                )}
            >
                {children}
            </main>
        </div>
    );
}
